<template>
  <div class="detail_main bg_detail is-scrollable has-background-white">
    <div class="detail_img_info" v-if="detailResauxComplet.listeFaces.length">
      <div class="level is-mobile diapo_mount">
        <div class="level-left is-marginless">
          <a class="button has-text-white is-rounded diapo_button"
            @click="$parent.show = false">
            <span class="icon">
              <b-icon icon="chevron-left"></b-icon>
            </span>
            <label>Retour</label>
          </a>
        </div>
        <div class="level-right">
          <div class="button has-text-white is-rounded rightViolet diapo_count">
            <label>{{currentImg + 1}}/{{detailResauxComplet.listeFaces.length}}</label>
          </div>
        </div>
      </div>
      <img
        :src="url(img)"
        class="imageBgOpp imgGoToTop"
        v-touch:swipe.left="swipeLeft()"
        v-touch:swipe.right="swipeRight()">
    </div>
    <div class="detail_img_info" v-else>
      <a
        class="button has-text-white is-rounded diapo_button"
        @click="$parent.show = false">
        <span class="icon">
          <b-icon
            icon="chevron-left">
          </b-icon>
        </span>
        <label>Retour</label>
      </a>
      <img :src="url(detailResauxComplet.urlPhoto)" class="imageBgOpp imgGoToTop">
    </div>
    <div class="leftVert topViolet rightVert bottomVert">
      <div class="tabs bottomVert">
        <ul class="p_size12 has-text-weight-bold">
          <li :class="{'underline is-active': active === 1}"
              @click="active = 1"
              class="is-paddingless">
            <a>Proposition</a>
          </li>
          <li :class="{'underline is-active': active === 2}"
              @click="active = 2"
              class="is-paddingless">
            <a>Caractéristiques</a>
          </li>
        </ul>
      </div>
      <div v-if="active === 1">
        <div class="columns is-mobile is-marginless is-multiline color-icon detail_content_propo">
          <div class="column bottomViolet is-paddingless is-6"
               v-if="detailResauxComplet.extensionOpportunite.quantite">
            <div class="media">
              <b-icon
                icon="timer"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Durée
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{formatDureeNum(detailResauxComplet.extensionOpportunite.typeTarification,
                    detailResauxComplet.extensionOpportunite.quantite)}}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="tarif"
            class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="cash"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  {{detailResauxComplet.extensionOpportunite.tarifNet ?
                    'Tarif Net HT' : 'Tarif HT'}}
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{formatNum(tarif)}}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailResauxComplet.extensionOpportunite.fraisAdserving"
            class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="tooltip-plus"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Frais Adserving
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{fraisAdserving}}
                </p>
              </div>
            </div>
          </div>
          <div class="column bottomViolet is-paddingless is-6"
               v-if="detailResauxComplet.extensionOpportunite.typeTarification">
            <div class="media">
              <b-icon
                icon="cellphone-screenshot"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Mode de diffusion
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{modeDiff(detailResauxComplet.extensionOpportunite.typeTarification)}}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailResauxComplet.extensionOpportunite.nbDiffusion"
            class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="counter"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Diffusion/jour
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{detailResauxComplet.extensionOpportunite.nbDiffusion}}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailResauxComplet.extensionOpportunite.spotsPub"
            class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="camera-metering-spot"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Spot(s) Publicitaire(s)
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{detailResauxComplet.extensionOpportunite.spotsPub}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="detailResauxComplet.extensionOpportunite.commentaire">
          <p class="p_size12 has-text-weight-bold topViolet bottomViolet has-text-link">
            Commentaire:
          </p>
          <div class="commentaire">
            <p class="has-text-link has-text-justify p_size11">
              {{detailResauxComplet.extensionOpportunite.commentaire}}
            </p>
          </div>
        </div>
      </div>
      <div v-if="active === 2">
        <p class="is-size-7 bottomViolet">
          <label class="has-text-default">
            Nom du réseau
          </label><br>
          <strong class="p_size12 has-text-link">
            {{detailResauxComplet.libelle}}
          </strong>
        </p>
        <div class="columns is-mobile is-multiline color-icon">
          <div class="column is-6">
            <div class="media">
              <b-icon
                icon="city"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Ville
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{detailResauxComplet.ville}}
                </p>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="media">
              <b-icon
                icon="vector-intersection"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Format
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{detailResauxComplet.format}}
                </p>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="media">
              <b-icon
                icon="sign-text"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Nombre de d'écrans
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{detailResauxComplet.nbFaces}}
                </p>
              </div>
            </div>
          </div>
          <div v-if="detailResauxComplet.extensionOpportunite.periode" class="column is-12">
            <div class="media">
              <b-icon
                icon="timer"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Période
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{detailResauxComplet.extensionOpportunite.periode}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!detailResauxComplet.select" @click="contolSelect()"
         class="navbar is-fixed-bottom button is-primary boutonSelectM has-text-weight-bold">
      <p class="p_size11 centreM">Ajouter a ma sélection</p>
    </div>
    <div v-else @click="contolSelect()"
         class="navbar is-fixed-bottom button boutonRed boutonSelectM has-text-weight-bold">
      <p class="p_size11 centreM">Retirer de ma sélection</p>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { urlPhoto, formatNum, formatDate, formatDureeNum, modeDiff } from '@/services/opportunite/formatTab';

export default {
  name: 'detailReseauxNumeriqueCompletDiapo',
  props: ['detailResauxComplet'],
  data() {
    return {
      active: 1,
      currentImg: 0,
    };
  },
  computed: {
    date() {
      return formatDate(this.detailResauxComplet.extensionOpportunite.date);
    },
    fraisAdserving() {
      return formatNum(this.detailResauxComplet.extensionOpportunite.fraisAdserving);
    },
    img() {
      return this.detailResauxComplet.listeFaces[this.currentImg].urlPhoto;
    },
    tarif() {
      if (this.detailResauxComplet.extensionOpportunite.tarifNet) {
        return this.detailResauxComplet.extensionOpportunite.tarifNet;
      }
      return this.detailResauxComplet.extensionOpportunite.tarifHt;
    },
  },
  methods: {
    ...mapActions([
      'add',
      'substract',
      'addNbSelect',
      'substractNbSelect',
    ]),
    url(data) {
      return urlPhoto(data);
    },
    contolSelect() {
      this.detailResauxComplet.select = !this.detailResauxComplet.select;
      if (this.detailResauxComplet.select) {
        this.add(this.tarif);
        this.addNbSelect();
      } else {
        this.substract(this.tarif);
        this.substractNbSelect();
      }
    },
    formatNum(t) {
      return formatNum(t);
    },
    close() {
      this.$parent.show = false;
    },
    modeDiff(t) {
      return modeDiff(t);
    },
    formatDureeNum(t, q) {
      return formatDureeNum(t, q);
    },
    swipeLeft() {
      return () => {
        if (this.currentImg === this.detailResauxComplet.listeFaces.length - 1) {
          this.currentImg = 0;
        } else {
          this.currentImg += 1;
        }
      };
    },
    swipeRight() {
      return () => {
        if (this.currentImg === 0) {
          this.currentImg = this.detailResauxComplet.listeFaces.length - 1;
        } else {
          this.currentImg -= 1;
        }
      };
    },
  },
  mounted() {
    const test = document.querySelector('html');
    const test2 = document.querySelector('body');
    test.style.overflow = 'hidden';
    test2.style.overflow = 'hidden';
  },
  destroyed() {
    const test = document.querySelector('html');
    const test2 = document.querySelector('body');
    test.style.overflow = '';
    test2.style.overflow = '';
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/propositions/reseauxNumeriques/detailReseauxNumeriqueCompletDiapo.vue